<template>
  <div>
    <div
      v-if="isMyRequest && (request.status === 'ACTIVE' || request.status === 'EXPIRED' || request.status === 'DISCUSSING')"
      class="card"
    >
      <div class="card-body">
        <p>{{ $t('requestCloseFlow.sorunuzTamamlandqdanVYaEhtiyacOlmadZamanSorunuzuBa') }}</p>

        <button
          class="btn btn-block btn-outline-danger"
          @click="closeRequestSelectResult()"
        >
          {{ $t('requestCloseFlow.sorunuBala') }}
        </button>
      </div>
    </div>
    <b-modal
      id="modal-close-is-success"
      centered
      :title="$t('requestCloseFlow.sorununBalanmas')"
      :hide-footer="true"
      class="theme-modal"
    >
      <div>
        <p class="lead">
          {{ $t('requestCloseFlow.zhmtOlmasaSorunuzunNticsiIlBalMlumatVerin') }}
        </p>


        <div v-if="request.requestType==='PQT' && request.autoWinner===2">
          <div class="my-3 text-danger">
            {{ $t('requestCloseFlow.sorunuUurluBalamaqNTklifVernXslrlMzakirEdin') }}
          </div>
        </div>
        <button
          class="btn btn-lg btn-block btn-success my-3"
          @click="closeRequestSuccessful"
        >
          {{ $t('requestCloseFlow.sorumUurluOldu') }}
        </button>

        <button
          class="btn btn-lg btn-block btn-warning my-3"
          @click="closeRequestUnSuccessful"
        >
          {{ $t('requestCloseFlow.sorumUursuzOldu') }}
        </button>
      </div>
    </b-modal>
    <b-modal
      id="modal-close-winner-selection"
      centered
      :title="$t('requestCloseFlow.sorununBalanmas')"
      :hide-footer="true"
      class="theme-modal"
    >
      <div>
        <div v-if="uniqueCommentList.length<1">
          <div class="text-danger">
            {{ $t('requestCloseFlow.buSoruNHeBirXsTklifVermmidir') }}
          </div>
        </div>
        <div v-else>
          <label
            class="lead"
            for="closeRequestNote"
          >{{ $t('requestCloseFlow.qalibTklifiSein') }}</label>

          <div
            v-for="c in uniqueCommentList"
            :key="c.id"
            class="form-check mb-3"
          >
            <input
              :id="`rwc_${c.id}`"
              v-model="closeRequestWinners"
              class="form-check-input"
              type="checkbox"
              :value="c.id"
            >
            <label
              class="form-check-label"
              :for="`rwc_${c.id}`"
            >
              <strong>{{ c.user.name }} {{ c.user.surname }}</strong> <br>
              {{ c.company.name }} {{ getCompanyFormat(c.company.format) }}
            </label>
          </div>


          <button
            class="btn btn-block btn-warning"
            @click="closeRequest(1)"
          >
            {{ $t('requestCloseFlow.sorumUurluOldu') }}
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-close-winner-selection-pqt"
      centered
      :title="$t('requestCloseFlow.sorununBalanmas')"
      :hide-footer="true"
      class="theme-modal"
    >
      <div />
      <div>
        <div v-if="offers.length<1">
          <div class="text-danger">
            {{ $t('requestCloseFlow.buSoruNHeBirXsTklifVermmidir') }}
          </div>
        </div>
        <div v-else>
          <label
            class="lead"
            for="closeRequestNote"
          >{{ $t('requestCloseFlow.qalibTklifiSein') }}</label>

          <div
            v-for="c in offers"
            :key="c.id"
            class="form-check mb-3"
          >
            <input
              :id="`rwc_${c.id}`"
              v-model="closeRequestWinners"
              class="form-check-input"
              type="checkbox"
              :value="c.id"
            >
            <label
              class="form-check-label"
              :for="`rwc_${c.id}`"
            >

              {{ c.requestUser.company.name }} {{ getCompanyFormat(c.requestUser.company.format) }}
            </label>
          </div>

          <div>
            <label
              for="closeRequestNote"
              class="lead"
            >{{ $t("requestCloseFlow.qalibScmnzEsasLdnr") }}</label>
            <textarea
              id="closeRequestNote"
              v-model.trim="closeRequestNote"
              class="form-control"
              rows="3"
              required
            />
            <div
              v-if="closeRequestNote.length<20"
              class="text-secondary mt-1"
            >
              {{ $t("requestCloseFlow.sorguQyd20SmvolOlmalidi") }}
            </div>
            <div class="text-danger">
              {{$t("requestCloseFlow.qeydEtdynzSbbDigerIstrakcGndrl")}}
            </div>
          </div>
          <button
            class="btn btn-block btn-warning"
            @click="closeRequest(1)"
          >
            {{ $t('requestCloseFlow.sorumUurluOldu') }}
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-close-un-success"
      centered
      :title="$t('requestCloseFlow.sorununBalanmas')"
      :hide-footer="true"
      class="theme-modal"
    >
      <form @submit.prevent="closeRequest(0)">
        <div>
          <label
            for="closeRequestNote"
            class="lead"
          >{{ $t('requestCloseFlow.sorunuzunUursuzOlmasnnSbbiniQeydEdin') }}</label>
          <textarea
            id="closeRequestNote"
            v-model.trim="closeRequestNote"
            class="form-control"
            rows="3"
            required
          />
          <div
            v-if="closeRequestNote.length<20"
            class="text-secondary mt-1"
          >
            {{ $t("requestCloseFlow.sorguQyd20SmvolOlmalidi") }}
          </div>
          <div class="text-danger">
            {{ $t("requestCloseFlow.qeydEtdynzSbbDigerIstrakcGndrl") }}
          </div>
        </div>

        <div class="my-2 text-info">
          {{ $t('requestCloseFlow.sizinQeydinizGlckdDahaUurluSorularnYaradlmasVCavab') }}
        </div>
        <button
          type="submit"
          class="btn btn-block btn-warning"
        >
          {{ $t('requestCloseFlow.sorumUursuzOldu') }}
        </button>
      </form>
    </b-modal>
  </div>
</template>
<script>
import {closeRequest} from "@/repositories/GeneralDataRepository";
import {getCompanyFormat} from "@/repositories/Utils";
import {mapState} from "vuex";

export default {
  name: 'RequestCloseFlow',
  props: {
    isMyRequest: {},
    request: {},
    offers: {},
    comments: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      closeRequestWinners: [],
      closeRequestNote: '',
    }
  },
  computed: {

    ...mapState({
      token: state => state.auth.token
    }),

    uniqueCommentList() {
      let list = [];
      let idS = [];

      this.comments.forEach(c => {
        if (idS.indexOf(c.user.id) === -1) {
          list.push(c);
          idS.push(c.user.id);
        }
      });

      return list;

    },
  },
  methods: {
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    closeRequestSelectResult() {
      this.$bvModal.show('modal-close-is-success');
    },

    closeRequestSuccessful() {
      if (this.request.requestType === 'RFQ' || (this.request.requestType === 'RFI' && this.request.requestSubType === 'purchase') || (this.request.requestType === 'PQT' && this.request.autoWinner === 1)) {
        if (this.request.requestType === 'PQT' && this.request.autoWinner === 1) {
          this.$bvModal.show('modal-close-winner-selection-pqt');
        } else {
          this.$bvModal.show('modal-close-winner-selection');
        }
      } else {
        this.closeRequest(1);
      }
    },
    closeRequestUnSuccessful() {
      this.$bvModal.show('modal-close-un-success');
    },

    closeRequest(success) {

      if (
          (this.request.requestType === 'RFQ'
              || (this.request.requestType === 'RFI' && this.request.requestSubType === 'purchase') || (this.request.requestType === 'PQT' || this.request.autoWinner === 1))
          && this.closeRequestWinners.length < 1 && success === 1
      ) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("requestCloseFlow.buSrgnUgurluBglmq"),
          icon: 'warning'
        })
      } else {

        closeRequest(this.token, this.request.id, success, this.closeRequestNote, this.closeRequestWinners).then(data => {
          if (data.code === 200) {
            this.$bvModal.hide('modal-close-is-success');
            this.$bvModal.hide('modal-close-un-success');
            this.$bvModal.hide('modal-close-winner-selection');
            this.$bvModal.hide('modal-close-winner-selection-pqt');
            this.$emit('refresh');
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
